/**
 * GG Bottle Quantity Guard v1.1
 * Sperrt Plus/Minus und freie Eingabe bei Bottle-Promotion-Positionen.
 * Entfernen-Button bleibt aktiv.
 */
(function () {
  'use strict';

  var LOCK_ATTR = 'data-gg-bottle-locked';
  var REMOVE_CLASS = 'cart-items__remove';
  var REMOVE_ATTR = 'on:click';

  function isRemoveButton(btn) {
    return (
      btn.classList.contains(REMOVE_CLASS) ||
      (btn.getAttribute(REMOVE_ATTR) || '').indexOf('onLineItemRemove') !== -1
    );
  }

  function lockWrapper(wrapper) {
    // Plus/Minus sperren, Entfernen ausdrücklich erlauben
    wrapper.querySelectorAll('button').forEach(function (btn) {
      if (isRemoveButton(btn)) return;

      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.style.setProperty('opacity', '0.35', 'important');
      btn.style.setProperty('pointer-events', 'none', 'important');
    });

    // Direkte Mengeneingabe sperren
    wrapper
      .querySelectorAll('input[type="number"], input[name="quantity"]')
      .forEach(function (inp) {
        inp.readOnly = true;
        inp.setAttribute('aria-readonly', 'true');
        inp.style.setProperty('pointer-events', 'none', 'important');
        inp.style.setProperty('user-select', 'none', 'important');
      });
  }

  function lockAllBottleSelectors() {
    document
      .querySelectorAll('[' + LOCK_ATTR + '="true"]')
      .forEach(lockWrapper);
  }

  // Initial sperren
  lockAllBottleSelectors();

  // Für verzögertes Rendering
  setTimeout(lockAllBottleSelectors, 300);
  setTimeout(lockAllBottleSelectors, 800);

  // Für dynamische Warenkorb-Updates und Cart Drawer
  var observerTimeout = null;

  var observer = new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        if (node.nodeType !== 1) return false;

        return (
          node.matches?.('[' + LOCK_ATTR + '="true"]') ||
          node.querySelector?.('[' + LOCK_ATTR + '="true"]')
        );
      });
    });

    if (!relevant) return;

    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(lockAllBottleSelectors, 50);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Zusätzliche Theme-Events
  ['cart:updated', 'cart-drawer:open', 'shopify:section:load'].forEach(
    function (eventName) {
      document.addEventListener(eventName, function () {
        setTimeout(lockAllBottleSelectors, 100);
      });
    }
  );
})();